/* eslint-disable no-console, no-unused-expressions */
import config from 'config';

const isDev = (config.env === 'development');

// register a virtual pageview
export const sendPageview = (pathname = location.pathname) => {
  isDev && console.log(`[ga] send pageview ${ pathname }`);
  window.ga && window.ga('send', {
    hitType: 'pageview',
    page: pathname,
  });
};

// register an arbitrary event
export const sendEvent = (category, action) => {
  isDev && console.log(`[ga] send event ${ category } ${ action }`);
  window.ga && window.ga('send', {
    hitType: 'event',
    eventCategory: category,
    eventAction: action,
    // eventLabel: label,
  });
};



// WEBPACK FOOTER //
// ./src/lib/analytics.js